import { gql } from '@apollo/client';

export const DELETE_KPI_CONFIG_MUTATION = gql`
  mutation DeleteKpiConfig($id: Int!) {
    p {
      deleteKpiConfig(id: $id) {
        success
        message {
          code
          message
        }
        content
      }
    }
  }
`;
